'use client';
import React, { useEffect, useRef } from 'react';
import Script from 'next/script';

function BannerVips() {
  const banner = useRef<HTMLDivElement>(null);

  const atOptions = {
    key: '8f92dc52df247e90db4f1d33646e2519',
    format: 'iframe',
    height: 50,
    width: 320,
    params: {},
  };

  useEffect(() => {
    if (banner.current && !banner.current.firstChild && window.innerWidth < 768) {
      const conf = document.createElement('script');
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://www.vipads.live/vn/560AD033-54A4-2504-33-8EB6DF6B47D8.blpha`;

      banner.current.append(conf);
      banner.current.append(script);
    }
  }, [banner]);

  return (
    <div>
      <div
        className="mx-2 my-5 md:hidden justify-center items-center text-white text-center"
        ref={banner}
      ></div>
      {/* <Script
        src="https://www.vipads.live/vn/560AD033-54A4-2504-33-8EB6DF6B47D8.blpha"
        strategy="lazyOnload"
      /> */}
    </div>
  );
}

export default BannerVips;
